import React from 'react';

import Logo from '../../images/logo-with-text.svg';
class Navigation extends React.Component {
  render() {
    return(
      <div className="nav-container ">
            <nav id="menu1" className="bar bar--sm bar-1 hidden-xs ">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-2 col-md-2 hidden-xs">
                            <div className="bar__module">
                                <a id="home--logoicon--navigation-link" href="/">
                                    <img className="logo logo-dark" alt="logo" src={Logo} />
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-10 col-md-12 text-right text-left-xs text-left-sm">
                            <div className="bar__module">
                                <ul className="menu-horizontal text-left">

                                    <li className="dropdown">
                                      <a id="home--features--header-link" href="/features" className="dropdown__trigger">Features</a>
                                    </li>

                                    <li id="home--pricing--header-link" className="dropdown">
                                      <a href="/pricing" className="dropdown__trigger">Pricing</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="bar__module">
                                <a id="home--login--header-link" className="btn btn--sm type--uppercase" href="https://dashboard.popupfox.com/Login">
                                    <span className="btn__text">
                                        Login
                                    </span>
                                </a>
                                <a id="home--try-builder--header-link" className="btn btn--sm btn--primary type--uppercase" href="https://dashboard.popupfox.com/register">
                                    <span className="btn__text">
                                        Try Builder
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    )
  }
}

export default Navigation;